export default {
  // NOTE: if we use a staff view, positions are obsolete
  POSITIONS: {
    1: "Pitcher",
    2: "Catcher",
    3: "1st Baseman",
    4: "2nd Baseman",
    5: "3rd Baseman",
    6: "Shortstop",
    7: "Left Fielder",
    8: "Center Fielder",
    9: "Right Fielder",
    10: "Designated Hitter",
    11: "Left-Handed Reliever",
    12: "Left-Handed Starter",
    13: "Right-Handed Reliever",
    14: "Right-Handed Starter",
    15: "Infielder",
    16: "Utility",
    17: "Outfielder",
    18: "Pinch Hitter",
    19: "Unknown",
    20: "Athletic Trainer",
    21: "Conditioning Coach",
    22: "Manager",
    23: "Coach",
    24: "Did Not Play",
    25: "Starting Pitcher",
    26: "Relief Pitcher",
    27: "Team Staff",
    37: "Right Handed Pitcher",
    38: "Left Handed Pitcher",
    39: "CUSTOM"
  },
  STAFF: {
    COACH: {
      value: "COACH",
      category: 5,
      positionIds: [23, 39]
    },
    MANAGER: {
      value: "MANAGER",
      category: 6,
      positionIds: [22]
    },
    TRAINER: {
      value: "TRAINER",
      category: 7,
      positionIds: [20, 21]
    },
    TEAM_STAFF: {
      value: "TEAM_STAFF",
      name: "Team Staff",
      category: 8,
      positionIds: [27]
    },
    CUSTOM: {
      value: "CUSTOM",
      category: 9,
      positionIds: [39]
    }
  },
  PLAYER: {
    CATCHER: "Catcher",
    PITCHER: "Pitcher",
    INFIELD: "Infield",
    OUTFIELD: "Outfield"
  }
};

export const STAFF_POSITION_ABBREVIATIONS = ["UN", "ATC", "CC", "MA", "CO", "TS"];
